import { Modal } from '@doordash/component-modal'
import { Text, Inline, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import {
  RedCardDisclaimer,
  RedCardIcon,
  RedCardIconContainer,
} from './red-card'
import { ActivationKitModalList, HotBagImage, PackagingImage } from './styles'

import t from './strings'

const ActivationKitModal: React.SFC<{
  onClose: any
  redCardOnly?: boolean
  showPackageImage?: boolean
}> = props => (
  <Modal
    {...props}
    title={t.title()}
    primaryAction={{
      text: t.button(),
      onClick: props.onClose,
    }}
    actionsFillContainer={true}
    size={Modal.Sizes.Small}
  >
    <StackChildren size={StackChildren.Sizes.Large}>
      {props.showPackageImage && <PackagingImage />}
      <ActivationKitModalList>
        <Inline size={Inline.Sizes.Large}>
          <RedCardIconContainer>
            <RedCardIcon />
          </RedCardIconContainer>
        </Inline>
        <Text styles={Text.Styles.ContentBody}>
          <Text styles={Text.Styles.Bold16}>{`1. ${t.redCardTitle()}`}</Text>
          {t.redCardBody()}
        </Text>
      </ActivationKitModalList>
      {props.redCardOnly ? (
        <RedCardDisclaimer />
      ) : (
        <ActivationKitModalList>
          <Inline size={Inline.Sizes.Large}>
            <HotBagImage />
          </Inline>
          <Text styles={Text.Styles.ContentBody}>
            <Text styles={Text.Styles.Bold16}>{`2. ${t.hotBagTitle()}`}</Text>
            {t.hotBagBody()}
          </Text>
        </ActivationKitModalList>
      )}
    </StackChildren>
  </Modal>
)

ActivationKitModal.defaultProps = {
  redCardOnly: false,
  showPackageImage: true,
}

export default ActivationKitModal
